export default __webpack_public_path__ + "static/media/20.432c7281.jpg";